// Clinic Configuration for Creek Crossing Dental Care
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Creek Crossing Dental Care",
  clinicId: "creekcrossingdentalcare",
  clinicUrl: "https://creekcrossingdentalcare.com",
  // Contact Information
  phoneNumber: "469-333-6158",
  phoneNumberRaw: "+14693336158", // For tel: and sms: links
  email: "dentist@creekcrossingdentalcare.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=creekcrossingdentalcare&agentId=e5809626-3c52-463a-8807-fb08c68187ad",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/creekcrossingdentalcare/voice",

  // Location
  address: "1927 FAITHON P LUCAS SR BLVD Ste 120 MESQUITE TX 75181-1698, United States",
  addressShort: "1927 FAITHON P LUCAS SR BLVD Ste 120 MESQUITE TX 75181-1698",
  city: "MESQUITE",
  hcity: "MESQUITE",
  state: "Texas",
  stateShortForm: "TX",
  PostalCode: "75181",
  // Map Links
  mapUrl: "https://maps.app.goo.gl/FqMgZSbN6tCqQ99m6",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d40899.07139408473!2d-96.554127!3d32.743937!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864eafc3ef2e13ed%3A0xb8e78179a0b23bfc!2sCreek%20Crossing%20Dental%20Care%20And%20Orthodontics!5e1!3m2!1sen!2sin!4v1759830383506!5m2!1sen!2sin',
  iframeTitle: "Creek Crossing Dental Care",

  //membership
  membership: "https://member.kleer.com/?slug=BV6J",

  // Sunbit
  sunbitUrl: "https://apply.sunbit.com/TodaysDentalPartners-CreekCrossingDentalCare",

  // Cherry
  cherryUrl: "https://pay.withcherry.com/creek-crossing-dental-care---dentist-in-mesquite?utm_source=practice&utm_medium=email&m=66576",


  // Analytics
  clarityProjectId: "q5nwcwxs47",

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/creekcrossingdentalcare",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/creekcrossingdentalcare",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/creekcrossingdentalcare",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/creekcrossingdentalcare",
    instagram: "https://www.instagram.com/creek_crossing_dental/",
    twitter: "https://x.com/Creek_Dent",
    linkedin: "https://www.linkedin.com/company/creek-crossing-dental-care/",
    youtube: "https://www.youtube.com/@creekcrossingdentalcare",
  },

  // Open Dental Configuration
  defaultProvNum: 1,
  defaultOpNum: 11,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: "New patient emergency/other",
      label: "New patient emergency/other",
      duration: 30,
      opNum: 9,
      AppointmentTypeNum: 5,
    },
    {
      value: "Existing patient emergency/other",
      label: "Existing patient emergency/other",
      duration: 30,
      opNum: 11, // DEFAULT_OP_NUM
      AppointmentTypeNum: 8,
    },
    {
      value: "Existing patient current treatment Plan",
      label: "Existing patient current treatment Plan",
      duration: 30,
      opNum: 11, // DEFAULT_OP_NUM
      AppointmentTypeNum: 3,
    },
  ],

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:${this.phoneNumberRaw}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;  
